import * as R from 'ramda'
import React, { Component } from 'react'
import PouchDB from 'pouchdb-browser'
import moment from 'moment'

// if (DEBUG) PouchDB.debug.enable('*')

export default class PouchRedux extends Component {
	componentWillMount() {
		this.log('componentWillMount')
		this.init()
	}
	componentWillReceiveProps(nextProps) {
		this.log('componentWillReceiveProps', nextProps.data)
		this.internalChange(nextProps.data)
	}
	componentWillUnmount() {
		this.log('componentWillUnmount')
		this.cleanup()
	}
	init() {
		this.log = this.log.bind(this)
		this.error = this.error.bind(this)
		let { props, log, error } = this
		let { db, data, onIndex } = props
		log('init')()
		this.db = new PouchDB(db)
		// initial load
		let listen = () => {
			this.dbChanges = this.db.changes({
				live: true
			  , since: 'now'
			  , include_docs: true
			  , attachments: true
			  , binary: true
			})
			.on('change', x => this.externalChange(x))
			.on('error', error('changes'))
		}
		if (data) {
			log('data')(data)
			this.set(data, { onIndex })
			listen()
		} else {
			log('allDocs')()
			this.db.allDocs({ include_docs: true, attachments: true, binary: true })
			.then(x => {
				let docs = x.rows.map(x => x.doc)
				log('allDocs')(docs)
				this.set(docs, props)
				listen()
			})
			.catch(error('allDocs'))
		}
	}
	internalChange(next) {
		let { db, data, props, log, error } = this
		let { onIndex } = props
		if (next === data || !next) return
		log('internalChange')(next)
		let deleted = Object.assign({}, data)
		R.map(o => {
			if (!o) return
			let id = o._id
			delete deleted[id]
			let old = data[id]
			if (o !== old) {
				if (!R.equals(old, o)) {
					if (old) {
						db.get(o._id).then(resp => {
							o._rev = resp._rev
							o.updatedAt = moment().format()
							o.updatedBy = global.store.getState().session.username
							o.channels = ['manager'/*, global.store.getState().session.userID*/]
							return db.put(o)
						})
						.then(log('internalChange.PUT'))
						.catch(error('internalChange.PUT'))
					} else {
						o.createdAt = moment().format()
						o.createdBy = global.store.getState().session.username
						o.channels = ['manager'/*, global.store.getState().session.userID*/]
						db.put(o)
						.then(log('internalChange.POST'))
						.catch(error('internalChange.POST'))
					}
				}
				this.put(o, { onIndex })
			}
		}, next)
		R.map(o => {
			this.del(o, { onIndex })
			o = {
				_id: o._id
			  , _deleted: true
			  , type: o.type
			  , channels: o.channels
			  , createdAt: o.createdAt
			  , createdBy: o.createdBy
			  , updatedAt: moment().format()
			  , updatedBy: global.store.getState().session.username
			}
			db.get(o._id).then(resp => {
				o._rev = resp._rev
				db.put(o)
				.then(log('internalChange.DEL'))
				.catch(error('internalChange.DEL'))
			})
		}, deleted)
	}
	externalChange(change) {
		let { data, props, log } = this
		log('externalChange')(change)
		let id = change.id
		let old = data[id]
		if (change.deleted) {
			if (old) {
				log('externalChange.DEL')(old)
				this.del(old, props)
			}
		} else { // updated/inserted
			let doc = change.doc
			let omitRev = R.omit(['_rev'])
			if (R.equals(omitRev(doc), omitRev(old))) {
				old._rev = doc._rev
			} else {
				log('externalChange.' + (old ? 'PUT' : 'POST'))(doc)
				this.put(doc, props)
			}
		}
	}
	set(data, props = {}) {
		let { log } = this
		let { onLoad, onIndex } = props
		if (R.is(Array, data)) {
			log('set')('array')
			var array = data
			data = R.indexBy(R.prop('_id'), data)
		} else {
			log('set')('map')
			var array = R.values(data)
		}
		this.data = data
		if (onLoad) {
			log('set')('onLoad')
			onLoad(data)
		}
		if (onIndex) {
			log('set')('index')
			this.idx = R.map(R.indexBy(R.prop('_id')), R.groupBy(R.prop('type'), array))
			log('set')('onIndex')
			onIndex(this.idx)
		}
	}
	put(doc, props = {}) {
		let { data, idx } = this
		let { onInsert, onUpdate, onIndex } = props
		let notify = data[doc._id] ? onUpdate : onInsert
		data[doc._id] = doc
		if (notify) notify(doc)
		if (onIndex) {
			this.idx = {
				...idx
			  , [doc.type]: {
			  		...idx[doc.type]
			  	  , [doc._id]: doc
				}
			}
			onIndex(this.idx)
		}
	}
	del(doc, props = {}) {
		let { data, idx } = this
		let { onDelete, onIndex } = props
		delete data[doc._id]
		if (onDelete) onDelete(doc._id)
		if (onIndex) {
			this.idx = {
				...idx
			  , [doc.type]: R.dissoc(doc._id, idx[doc.type])
			}
			onIndex(this.idx)
		}
	}
	cleanup() {
		let { dbChanges, log } = this
		log('cleanup')
		if (dbChanges) dbChanges.cancel()
	}
	log(src) {
		return (...rest) => {
			console.log('PouchRedux(' + this.props.db + ').' + src, ...rest)
		}
	}
	error(src) {
		return (err) => {
			let { props } = this
			let { db, onError } = props
			console.error('PouchRedux(' + db + ').' + src, err)
			if (onError) onError(err.toString())
		}
	}
	render() {
		return null
	}
}



// WEBPACK FOOTER //
// ./src/components/drivers/PouchRedux.js